import React from "react";
import Modal from "../../Components/Base/Modal";
import { SelectInput } from "../../Components";
import Unlock from "./Unlock";
const selectAgeList = [
  { id: "13-17", value: "13-17" },
  { id: "18-24", value: "18-24" },
  { id: "25-34", value: "25-34" },
  { id: "35-44", value: "35-44" },
  { id: "45-54", value: "45-54" },
  { id: "55-64", value: "55-64" },
  { id: "65+", value: "65+" },
];
export default function ModalAge(props) {
  const changeSelectedAge = (item) => {
    props.setSelectedAge(item.value)
  }
  return (
    <Modal addClass="modalCamp" close={props.close}>
      <div className="filterModal modal__camp">
        {props.isUserHasSubscription ?
          <div className="modal__assetDetail-delete perm long">
            <h4>Age</h4>
            <div className="dropdown-item age-select">
              <SelectInput
                selected={selectAgeList.filter(item => item.value === props.selectedAge)[0]}
                onChange={changeSelectedAge}
                list={selectAgeList}
                value={props.selectedAge}
              />
            </div>
            <div className="breakLine">
              <div className="campaignsCreate__btns filterbuttons">
                <div class="campaignsCreate__btns-row"><button className="clearButton" onClick={() => props.setSelectedAge('')}>Clear</button></div>
                <button className="button primary" onClick={props.handleSearch}>
                  Save
                </button>
              </div> </div>
          </div> :
          <Unlock onSaveCamp={props.close}></Unlock>
        }
      </div>
    </Modal>
  );
}
